import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { api } from "../lib/api";
import { motion } from "framer-motion";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";

  useEffect(() => {
    const cat = active === "all" ? undefined : active;
    api.products(cat ? { category: cat } : {}).then(setProducts).catch(() => {});
  }, [active]);

  useEffect(() => {
    api.categories().then(setCategories).catch(() => {});
  }, []);

  const activeCatMeta = useMemo(
    () => categories.find((c) => c.slug === active) || null,
    [categories, active]
  );

  return (
    <main data-testid="shop-page" className="pt-16">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-6">
        <div className="eyebrow mb-4">/ CATALOGUE</div>
        <motion.h1
          key={active}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
          className="font-display text-white text-6xl md:text-8xl tracking-tighter leading-[0.9]"
        >
          {activeCatMeta ? activeCatMeta.name : "The Store"}
        </motion.h1>
        {activeCatMeta && (
          <div className="mt-3 font-mono text-[11px] tracking-[0.28em] uppercase text-zinc-500">
            CH. {activeCatMeta.chapter_number} — {activeCatMeta.tagline}
          </div>
        )}
      </section>

      {/* Filter rail */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 sticky top-16 z-30 bg-[color:var(--bg-base)]/85 backdrop-blur-md border-y border-white/5">
        <div className="flex gap-2 overflow-x-auto pb-1">
          {[{ slug: "all", name: "All" }, ...categories].map((c) => {
            const on = active === c.slug;
            return (
              <button
                key={c.slug}
                data-testid={`filter-${c.slug}`}
                onClick={() => (c.slug === "all" ? setParams({}) : setParams({ category: c.slug }))}
                className={`shrink-0 font-mono text-[10px] tracking-[0.24em] uppercase px-4 h-9 border transition-colors ${
                  on ? "border-white bg-white text-black" : "border-white/15 text-zinc-300 hover:text-white hover:border-white/40"
                }`}
              >
                {c.name}
              </button>
            );
          })}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
        {products.length === 0 ? (
          <div className="font-mono text-zinc-400 text-sm py-24 text-center">// no products found in this division.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {products.map((p, i) => (
              <ProductCard key={p.id} p={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
